export default "__VITE_ASSET__c917e1c1__"